import * as React from "react"
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import IMealSlot from "../../../models/IMealSlot"
import IFoodCategory from "../../../models/IFoodCategory";
import IFoodGroup from "../../../models/IFoodGroup";

/**
 * Created by aditya on 18/07/18.
 */


export interface FoodGroupsEditorProps {
    updatedFoodGroups: {item: IFoodGroup}[],
    updateFoodGroupDistribution: (updatedMealSlots: {item: IFoodGroup}[]) => void,
    staticFoodGroups: IFoodCategory[]
}

class FoodGroupsEditor extends React.Component<FoodGroupsEditorProps> {

    constructor(props: FoodGroupsEditorProps) {
        super(props);
    }

    onThemeRemove = (index: number) => {
        let currUpdatedMealSlots = Object.assign([], this.props.updatedFoodGroups);
        currUpdatedMealSlots.splice(index, 1);
        this.props.updateFoodGroupDistribution(currUpdatedMealSlots);
    }

    onThemeChange = (updatedBreakup: IFoodGroup[], index: number) => {
        let currUpdatedMealSlots = Object.assign([], this.props.updatedFoodGroups);
        currUpdatedMealSlots[index] = updatedBreakup;
        this.props.updateFoodGroupDistribution(currUpdatedMealSlots);
    }

    render() {
        return (
            <div className="patient-meal-builder-editor food-groups-editor">
                <TemplatedList templateName={"foodGroups"} commonProps={{staticFoodGroups: this.props.staticFoodGroups}}
                               defaultItem={{item: []}}
                               listItems={this.props.updatedFoodGroups}
                               onItemRemove={this.onThemeRemove}
                               onItemChange={this.onThemeChange} autoAddNewRow={false} addRowText={"+ Add Theme"}/>
            </div>
        );
    }
}

export default FoodGroupsEditor